// src/utils/loadTranslations.ts

export interface Translations {
	[language: string]: {
	  [fileName: string]: any;
	};
      }
      
      export const loadTranslationsFromFiles = async (
	files: FileList
      ): Promise<Translations> => {
	const translations: Translations = {};
      
	const filePromises = Array.from(files).map((file) => {
	  return new Promise<void>((resolve) => {
	    const reader = new FileReader();
	    reader.onload = () => {
	      try {
		const data = JSON.parse(reader.result as string);
      
		// Extract language and file name from file path
		const pathParts = file.webkitRelativePath
		  ? file.webkitRelativePath.split('/')
		  : [file.name];
      
		let language = '';
		let fileName = '';
      
		if (pathParts.length >= 2) {
		  language = pathParts[pathParts.length - 2];
		  fileName = pathParts[pathParts.length - 1].replace('.json', '');
		} else {
		  // Fallback if webkitRelativePath is not available
		  const nameParts = file.name.split('-');
		  language = nameParts[0];
		  fileName = nameParts.slice(1).join('-').replace('.json', '');
		}
      
		if (!translations[language]) {
		  translations[language] = {};
		}
		translations[language][fileName] = data;
	      } catch (error) {
		console.error(`Error parsing file ${file.name}:`, error);
	      }
	      resolve();
	    };
	    reader.readAsText(file);
	  });
	});
      
	await Promise.all(filePromises);
      
	return translations;
      };
      